import { Link } from "react-router-dom";

type CtaBandProps = {
  title: string;
  desc: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
};

export default function CtaBand({
  title,
  desc,
  primaryLabel = "立即投稿",
  primaryTo = "/submit",
  secondaryLabel = "查看选题库",
  secondaryTo = "/topics",
}: CtaBandProps) {
  return (
    <section className="w-full bg-secondary-900 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto w-full max-w-4xl text-center">
        <p className="mb-4 inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-accent-400">
          <span className="h-px w-6 bg-accent-400"></span>
          现在开始
        </p>
        <h2 className="font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl text-balance">
          {title}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-100/75 md:text-base">
          {desc}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to={primaryTo}
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer sm:w-auto"
          >
            <i className="ri-send-plane-fill text-base leading-none"></i>
            {primaryLabel}
          </Link>
          <Link
            to={secondaryTo}
            className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-background-100/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap cursor-pointer sm:w-auto"
          >
            {secondaryLabel}
            <i className="ri-arrow-right-line text-base leading-none"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}